// extracted by mini-css-extract-plugin
export var container = "Layout-module--container--uKGcW";
export var spikesContainer = "Layout-module--spikesContainer--iwfvS";
export var largeSpikes = "Layout-module--largeSpikes--yDlnJ";
export var backgroundContainer = "Layout-module--backgroundContainer--V47y3";
export var main = "Layout-module--main--Fiv02";
export var footer = "Layout-module--footer--yPmoy";